import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeStepState, shipmentPriceArrayState, exchangeRateState, arrivalCountryState } from "../../../atoms/createShipment";
import ShipmentPriceGetCardItem from "./ShipmentPriceGetCardItem";
import InsuranceSlideWarning from "./InsuranceSlideWarning";
import { Button } from "@mui/material";
import Errors from "../../../utils/Errors";
import axios from "../../../api/axios";
import React from "react";
import { useEffect } from "react";
import { shouldHideSupplier, hasPermissionType1Or2 } from "../../../utils/SpecialUserIds";

const ShipmentPriceGetM = () => {
  const setActiveStep = useSetRecoilState(activeStepState);
  const setExchangeRate = useSetRecoilState(exchangeRateState);

  const shipmentPriceArray = useRecoilValue(shipmentPriceArrayState);
  const arrivalCountry = useRecoilValue(arrivalCountryState);
  const sortedArray = [...shipmentPriceArray]?.sort(
    (a, b) => a.selling_price * a.exchange_rate - b.selling_price * b.exchange_rate
  );

  // Compare supplier 342 and 350; keep only the cheaper of the two. Leave others untouched.
  // Compare supplier 1342 and 1350; if 1342 is cheaper, show only 1342; if 1350 is cheaper, show both.
  // YETKİLİ (permission 1 veya 2): 342, 343, 348, 350  görünür - 1342, 1343, 1348, 1350 gizli
  // YETKİSİZ: 1342, 1343, 1348, 1350 görünür - 342, 343, 348, 350 gizli
  const filteredArray = React.useMemo(() => {
    let tempArray = [...(sortedArray || [])];

    // Yetki bazlı filtreleme (348 ve 1348 hariç, onlar aşağıda özel olarak ele alınır)
    tempArray = tempArray.filter((x) => {
      const id = Number(x?.supplier_id);
      // 348 ve 1348'i shouldHideSupplier'dan muaf tut
      if (id === 348 || id === 1348) return true;
      return !shouldHideSupplier(id);
    });

    // 348 ve 1348 özel mantığı (sadece ülkeye göre)
    const isUSArrival = (() => {
      const val = String(arrivalCountry || "").trim().toLowerCase();
      const synonyms = new Set(["us", "usa", "abd", "amerika", "amerika birleşik devletleri", "united states", "united states of america"]);
      return synonyms.has(val);
    })();

    // ABD + izin VAR → 348 göster, 1348 gizle
    // ABD + izin YOK → 1348 göster, 348 gizle
    // ABD dışı → 348 göster, 1348 gizle
    const hasPermission = hasPermissionType1Or2();

    tempArray = tempArray.filter((x) => {
      const id = Number(x?.supplier_id);
      if (id !== 348 && id !== 1348) return true;

      // Hem arrivalCountry hem de country_code_to kontrol et
      const code = String(x?.country_code_to || "").trim().toUpperCase();
      const isUS = isUSArrival || code === "US" || code === "USA";

      if (id === 348) return !isUS || hasPermission;
      if (id === 1348) return isUS && !hasPermission;
      return true;
    });

    // Filter for 342 and 350
    const supplier342 = tempArray?.find((x) => x?.supplier_id === 342);
    const supplier350 = tempArray?.find((x) => x?.supplier_id === 350);


    if (supplier342 && supplier350) {
      const price342 = (supplier342?.selling_price ?? 0) * (supplier342?.exchange_rate ?? 1);
      const price350 = (supplier350?.selling_price ?? 0) * (supplier350?.exchange_rate ?? 1);

      // Only if 342 is cheaper, remove 350; otherwise show both
      if (price342 < price350) {
        tempArray = tempArray.filter((x) => x?.supplier_id !== 350);
      }
    }

    // Filter for 1342 and 1350
    const supplier1342 = tempArray?.find((x) => x?.supplier_id === 1342);
    const supplier1350 = tempArray?.find((x) => x?.supplier_id === 1350);

    if (supplier1342 && supplier1350) {
      const price1342 = (supplier1342?.selling_price ?? 0) * (supplier1342?.exchange_rate ?? 1);
      const price1350 = (supplier1350?.selling_price ?? 0) * (supplier1350?.exchange_rate ?? 1);

      // If 1342 is cheaper, show only 1342; if 1350 is cheaper or equal, show both
      if (price1342 < price1350) {
        tempArray = tempArray.filter((x) => x?.supplier_id !== 1350);
      }
    }

    return tempArray;
  }, [sortedArray, arrivalCountry]);

  const member = JSON.parse(localStorage.getItem("user"));
  const memberId = member?.user?.user_member?.id;

  const getCurrency = () => {
    axios
      .get(`exchange-rate`)
      .then((response) => {
        setExchangeRate(response.data.data);
      })
      .catch((error) => {
        Errors(error);
      });
  };

  useEffect(() => {
    getCurrency();
  }, []);

  return (
    <div className="shipmentPrice-get-card">
      <InsuranceSlideWarning />
      {filteredArray?.map((item, key) => (
        <ShipmentPriceGetCardItem key={key} item={item} />
      ))}
      {filteredArray.length === 0 && (
        <article
          style={{
            backgroundColor: "var(--lighterBg)",
            padding: "20px",
            borderRadius: "var(--wrapperBorderRadius)",
            boxShadow: "var(--shadow)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "var(--gap2x)",
          }}
        >
          <svg
            width="146"
            height="146"
            viewBox="0 0 146 146"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M102.992 20.2779L116.26 33.5454C135.755 53.048 145.499 62.7919 145.499 74.8994C145.499 87.0142 135.755 96.7582 116.26 116.253C96.7573 135.756 87.0133 145.5 74.8985 145.5C62.791 145.5 53.0398 135.756 33.5445 116.261L20.277 102.993C9.07578 91.7847 3.47153 86.1877 1.39078 78.9159C-0.69722 71.6442 1.08628 63.923 4.65328 48.4877L6.70503 39.5847C9.69928 26.5927 11.2 20.0967 15.6443 15.6452C20.0958 11.2009 26.5918 9.7002 39.5838 6.70595L48.4868 4.64695C63.9293 1.0872 71.6433 -0.696302 78.915 1.38445C86.1868 3.47245 91.791 9.0767 102.992 20.2779ZM66.8075 89.8779C61.9283 85.0059 61.9645 78.0024 64.8863 72.4562C64.163 71.4114 63.8284 70.1463 63.9407 68.8806C64.053 67.6148 64.605 66.4284 65.501 65.5272C66.3969 64.6261 67.5802 64.0672 68.8453 63.9477C70.1104 63.8281 71.3774 64.1554 72.4263 64.8727C74.8913 63.5677 77.5955 62.8717 80.2925 62.9007C81.7346 62.9142 83.1124 63.4999 84.1226 64.5292C85.1328 65.5584 85.6927 66.9468 85.6793 68.3889C85.6658 69.8311 85.08 71.2088 84.0508 72.219C83.0216 73.2292 81.6331 73.7892 80.191 73.7757C78.5123 73.8377 76.9258 74.5594 75.7758 75.7839C72.97 78.5897 73.7023 81.4027 74.4925 82.1929C75.29 82.9832 78.0958 83.7154 80.9015 80.9097C86.5855 75.2257 96.402 73.3407 102.688 79.6264C107.567 84.5057 107.531 91.5092 104.609 97.0554C105.328 98.1004 105.659 99.3638 105.544 100.627C105.43 101.89 104.878 103.074 103.983 103.973C103.088 104.872 101.908 105.429 100.645 105.55C99.3824 105.67 98.1175 105.345 97.069 104.632C93.8155 106.416 90.0417 107.011 86.397 106.314C84.9838 106.023 83.7437 105.183 82.9497 103.979C82.1557 102.774 81.8727 101.303 82.163 99.8902C82.4534 98.4769 83.2933 97.2369 84.4979 96.4428C85.7025 95.6488 87.1733 95.3659 88.5865 95.6562C89.8698 95.9244 91.9433 95.5039 93.7195 93.7277C96.5253 90.9147 95.793 88.1089 95.0028 87.3187C94.2053 86.5285 91.3995 85.7962 88.5938 88.602C82.9098 94.2859 73.0933 96.1709 66.8075 89.8779ZM58.644 60.6242C59.9903 59.2775 61.0581 57.6788 61.7865 55.9194C62.5149 54.16 62.8896 52.2744 62.8893 50.3701C62.889 48.4659 62.5136 46.5804 61.7845 44.8213C61.0555 43.0621 59.9871 41.4638 58.6404 40.1176C57.2937 38.7713 55.695 37.7035 53.9356 36.9751C52.1762 36.2467 50.2906 35.872 48.3863 35.8723C46.4821 35.8727 44.5966 36.2481 42.8375 36.9771C41.0784 37.7061 39.48 38.7745 38.1338 40.1212C35.4149 42.841 33.8879 46.5295 33.8885 50.3753C33.8892 54.221 35.4176 57.909 38.1374 60.6278C40.8572 63.3467 44.5457 64.8737 48.3915 64.8731C52.2372 64.8724 55.9252 63.344 58.644 60.6242Z"
              fill="#007FFF"
            />
          </svg>
          <h5 style={{ color: "var(--text)" }}>Fiyat Bulunamadı</h5>
          <p
            style={{
              fontSize: "16px",
              maxWidth: "600px",
              width: "100%",
              textAlign: "center",
              color: "var(--text)",
            }}
          >
            Belirlediğiniz gönderi kritelerine uygun fiyat bulunamadı! Lütfen ölçü ve ülke
            seçiminizi kontrol ediniz.
          </p>
          <Button sx={{ padding: '10px 50px' }} className="iyzi-button-blue" onClick={() => setActiveStep(0)}>
            Başa Dön
          </Button>
        </article>
      )}
    </div>
  );
};

export default ShipmentPriceGetM;
